import type { AdvanceTableActionProps } from '@aibees/shared/features';
import { Enrichment } from '../../types';

export interface EnrichTableActionProps
  extends AdvanceTableActionProps<Enrichment> {
  className?: string;
}

export enum EnrichTableActionType {
  report,
  view,
}
